import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { bomItemSelector } from './bomItemSelector'

export const bomItemDimensionsSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(
      state,
      bomItemId,
      state.project.currentView === ProjectViews.AssemblyHierarchy
    )

    switch (bomItem?.type) {
      case 'Row':
        return bomItem.dimensionsSummary
    }

    return null
  }
